import { apiClient, buildQueryString } from '@/services/utils';

export default {
  destroy(wardrobeId, wardrobeOutfitId) {
    return apiClient.delete(`/wardrobes/${wardrobeId}/wardrobe_outfits/${wardrobeOutfitId}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/api/WardrobeOutfitService.js